import { TipoFascicolo } from './tipo-fascicolo';

export class TipoPratica {
  id: string;
  rimosso: boolean;
  descrizione: string;
  label: string;
  endpoint?: string;
  tipiFascicolo?: TipoFascicolo[];
}
